@if (layout.isMobile()) {
  <!-- Mobile topbar: hamburger + brand + avatar -->
  <header class="flex items-center px-4 h-14 border-b shrink-0 gap-3"
          style="background: var(--nexus-surface); border-color: var(--nexus-border);">
    <button type="button" (click)="layout.openDrawer()"
            class="w-10 h-10 flex items-center justify-center rounded-lg transition-colors hover:bg-white/5"
            aria-label="Open menu">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-[22px] h-[22px]"
           style="color: var(--nexus-text-muted)">
        <path d="M4 6h16M4 12h16M4 18h16"/>
      </svg>
    </button>

    <div class="flex items-center gap-2 flex-1 min-w-0">
      <img src="/nexus-logo.webp" alt="Nexus" class="w-7 h-7 object-contain"
           style="filter: drop-shadow(0 0 6px rgba(0,229,255,0.35))"/>
      <span class="text-sm font-bold tracking-wide" style="color: var(--nexus-cyan)">Nexus</span>
    </div>

    @if (authService.currentUser(); as user) {
      @if (user.role === 'westyx_admin') {
        <span class="text-[10px] font-bold tracking-widest px-2 py-0.5 rounded uppercase shrink-0"
              style="background:rgba(0,229,255,0.12);color:var(--nexus-cyan);border:1px solid rgba(0,229,255,0.3)">
          Platform admin
        </span>
      } @else if (roleBadgeLabel(); as label) {
        <span class="text-[10px] font-bold tracking-widest px-2 py-0.5 rounded uppercase shrink-0"
              style="background:rgba(255,255,255,0.06);color:var(--nexus-text-muted);border:1px solid var(--nexus-border)">
          {{ label }}
        </span>
      }
      <a routerLink="/settings" aria-label="Settings" class="shrink-0">
        <app-avatar [avatarUrl]="meProfile.avatarUrl()" [name]="displayLabel()"
                    [email]="authService.currentUser()?.email ?? ''" [size]="32" />
      </a>
    }
  </header>

} @else {
  <!-- Desktop topbar -->
  <header class="flex items-center justify-end px-6 h-14 border-b shrink-0"
          style="background: var(--nexus-surface); border-color: var(--nexus-border);">
    <div class="flex items-center gap-3">
      @if (!authService.isPlatformAdmin()) {
        <app-tenant-switcher />
      }
      @if (!authService.isPlatformAdmin()) {
        <div style="position:relative">
          <button class="nx-btn-ghost" style="position:relative;padding:6px 10px" (click)="whatsNewOpen.set(!whatsNewOpen())">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-4 h-4" style="color:var(--nexus-text-muted)">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
            @if (announcementsService.unreadCount() > 0) {
              <span style="position:absolute;top:4px;right:4px;width:7px;height:7px;border-radius:50%;background:var(--nexus-cyan);border:1.5px solid var(--nexus-surface)"></span>
            }
          </button>
          @if (whatsNewOpen()) {
            <div style="position:fixed;inset:0;z-index:99" (click)="onBackdropClick($event)" (keydown.escape)="closeWhatsNew()"></div>
            <div style="position:absolute;right:0;top:calc(100% + 8px);z-index:100">
              <app-whats-new-panel />
            </div>
          }
        </div>
      }

      @if (authService.currentUser(); as user) {
        @if (user.role === 'westyx_admin') {
          <span class="text-[10px] font-bold tracking-widest px-2 py-0.5 rounded uppercase"
                style="background:rgba(0,229,255,0.12);color:var(--nexus-cyan);border:1px solid rgba(0,229,255,0.3)">
            Platform admin
          </span>
        } @else if (roleBadgeLabel(); as label) {
          <span class="text-[10px] font-bold tracking-widest px-2 py-0.5 rounded uppercase"
                style="background:rgba(255,255,255,0.06);color:var(--nexus-text-muted);border:1px solid var(--nexus-border)">
            {{ label }}
          </span>
        }
        <a routerLink="/settings"
           class="flex items-center gap-2 px-2 py-1 rounded-lg transition-colors hover:bg-white/5"
           style="text-decoration:none" aria-label="Open user settings">
          <app-avatar [avatarUrl]="meProfile.avatarUrl()" [name]="displayLabel()"
                      [email]="authService.currentUser()?.email ?? ''" [size]="28" />
          <span class="text-xs max-w-[140px] truncate hidden sm:inline"
                style="color:var(--nexus-text-dim)">
            {{ displayLabel() }}
          </span>
        </a>
        <button (click)="logout()"
                class="flex items-center gap-1.5 text-[11px] font-medium px-3 py-1.5 rounded-lg transition-all hover:bg-red-500/10"
                style="color:var(--nexus-red);border:1px solid rgba(255,51,102,0.3)">
          <lucide-icon [img]="LogOutIcon" class="w-3.5 h-3.5"/>
          Log out
        </button>
      }
    </div>
  </header>

}
